import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import React, { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';

import { formatCPF } from 'utils/formatters';
import { getOriginSlug } from 'v3/data/store/onlineContracting/mapping';
import { OnlineContractingType } from 'v3/data/store/onlineContracting/types';
import { RoutesEnum } from 'v3/routes/enum';
import { FinancingStatus } from 'v3/shared/components/Status/FinancingStatus';
import { getChannelLabel } from 'v3/shared/components/Table/OnlineContractingTable/statusHelpers';
import { SubtitleMediumBold } from 'v3/shared/typography/SubtitleMedium';
import {
  AlignClientInfo,
  AlignValues,
  BodyLine,
  HeaderLine,
  Line,
  MainContainer,
  SeeMoreContainer,
  StatusContainer,
  SubtitleLine,
} from '../styles';

interface IMobileTable {
  contractingList: OnlineContractingType[];
}

export const OnlineContractingMobileTable: React.FC<IMobileTable> = ({ contractingList }) => {
  const navigate = useNavigate();

  const handleNavigation = (contracting: OnlineContractingType) => {
    const slug = getOriginSlug(contracting.creditSimulation.origin);
    navigate(
      slug ?
        `${RoutesEnum.ContractingOnline}/${slug}/${contracting.contractingKey}`
        : `${RoutesEnum.ContractingOnline}/${contracting.contractingKey}`,
    );
  };

  return (
    <Fragment>
      {contractingList.map((contracting) => {
        const { fullName, cpf } = contracting.person;
        const formattedCPF = formatCPF(cpf);
        const { vtexOrderId } = contracting.creditSimulation;

        return (
          <MainContainer key={contracting.contractingKey} onClick={() => handleNavigation(contracting)}>
            <AlignValues>
              <HeaderLine>ID do Pedido</HeaderLine>
              <AlignClientInfo>
                <BodyLine className="empty-line">{vtexOrderId ? vtexOrderId : ''}</BodyLine>
              </AlignClientInfo>
            </AlignValues>
            <AlignValues>
              <HeaderLine>Cliente</HeaderLine>
              <AlignClientInfo>
                <BodyLine>{fullName}</BodyLine>
                <SubtitleLine>{formattedCPF}</SubtitleLine>
              </AlignClientInfo>
            </AlignValues>
            <AlignValues>
              <HeaderLine>Canal</HeaderLine>
              <AlignClientInfo>
                <BodyLine>{getChannelLabel(contracting.creditSimulation.origin)}</BodyLine>
              </AlignClientInfo>
            </AlignValues>
            <AlignValues>
              <HeaderLine>Financiamento</HeaderLine>
              <AlignClientInfo>
                <StatusContainer>
                  <FinancingStatus contractingState={contracting.status} />
                </StatusContainer>
              </AlignClientInfo>
            </AlignValues>
            <Line />
            <SeeMoreContainer>
              <SubtitleMediumBold>Ver mais</SubtitleMediumBold>
              <ArrowForwardIosIcon />
            </SeeMoreContainer>
          </MainContainer>
        );
      })}
    </Fragment>
  );
};
